CalendarEvent.$inject = [
    'CreateCashMovementModal',
    'CONST',
    'Time',
    '_',
    'Club',
    'moment',
];

function CalendarEvent(CreateCashMovementModal, CONST, Time, _, Club, moment) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        require: '^^atcCalendar',
        link: link,
        template: require('../../views/booking/calendar.event.directive.html'),
        restrict: 'A',
        scope: {
            event: '=event',
            slotsPerHour: '=',
            rowHeight: '=',
            date: '=',
            isFirstColumn: '='
        },
    };
    return directive;

    function link($scope, element, attrs, calendar) {
        var booking = $scope.event;
        const price = +booking.getPrice(booking.bookeable.day);
        $scope.pricing = price;
        //var rest_to_pay = `Resta abonar ${price - booking.attrs.balance_abs < 0 ? 0 : price - booking.attrs.balance_abs}`
        var times = booking.attrs;
        const SLOTS_PER_HOUR = $scope.slotsPerHour;

        /**
         * Returns the distance in divisible units to the top of the calendar
         * @method parseHours
         * @param  {Number} time 9.5
         * @param  {String} start The atc-calendar start: 8.5
         * @return {Number}
         */
        const parseHours = (time, start) =>
            (time - parseFloat(start)) * SLOTS_PER_HOUR;

        var start = parseHours(times.start.toFloat(), calendar.start),
            duration = parseHours(times.end.toFloat(), calendar.start) - start;

        // Format dates
        $scope.start_format = times.start.toStringFormalized();
        $scope.end_format = times.end.toStringFormalized();

        $scope.booking_date = calendar.currentDate;

        // Type figure
        _.extend($scope, getFigureType(booking));

        $scope.booking = booking;
        $scope.isDone = booking.isDone();
        //$scope.rest_to_pay = rest_to_pay;
        //getMovements($scope);

        $scope.user = booking.getUser();

        const rowHeight = $scope.rowHeight;

        var eventTop = start * rowHeight,
            eventHeight = duration * rowHeight;

        element
            .addClass(
                'single-event booking ' +
                    $scope.type_class +
                    ' type-' +
                    booking.getType().code,
            )
            .css({
                top: eventTop - 1 + 'px',
                height: eventHeight + 1 + 'px',
            });

        if (booking.isBlocker()) {
            element.addClass('blocker');
        }

        $scope.$watch('event.isDone()', function (isDone) {
            $scope.isDone = isDone;
            if (isDone) {
                element.addClass('done');
            } else {
                element.removeClass('done');
            }
        });

        $scope.$watch('event.deleted', function (deleted, old) {
            if (deleted && !old) {
                element.addClass('booking-deleted');
            }
        });

        $scope.registerCashMovement = function (type, booking, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            var start = booking.attrs.start;
            var datetime = Time.moment(calendar.currentDate);
            datetime.hour(start.hour);
            datetime.minute(start.min);
            var booking_date = datetime.format('YYYY-MM-DD HH:mm') + ':00';

            CreateCashMovementModal.open(
                {
                    type,
                    booking_id: booking.id,
                    datetime,
                    court: booking.court.name,
                    booking_date,
                    player: booking.attrs.user.name,
                    fixed: booking.attrs.fixed,
                },
                {
                    onUpdated: () => {
                        getMovements($scope);
                    },
                },
            );
        };
    }

    async function getMovements($scope) {
        const booking = $scope.booking;
        const movements = await Club.API.one(
            'booking',
            $scope.booking.id,
        ).customGET('movements', {
            date: $scope.booking_date.format('YYYY-MM-DD'),
        });

        $scope.movements = movements;
        const movements_total = movements.map((item) => {
            if (!item.payed)
                return parseInt(item.value) * parseInt(item.quantity);
            else return 0;
        });
        $scope.movements_total =
            movements_total.reduce((sum, val) => sum + val, 0) || 0;
        $scope.rest_to_pay = !booking.attrs.isDone
            ? `Resta abonar $ ${
                  $scope.pricing -
                      booking.attrs.balance_abs +
                      $scope.movements_total <
                  0
                      ? 0
                      : $scope.pricing -
                        booking.attrs.balance_abs +
                        $scope.movements_total
              }`
            : '';
    }
}

/**
 * Returns the type_format and type_class for that booking
 * @method getFigureType
 * @param  {Booking} booking
 * @return {object} type_figure
 * @return {string} type_figure.type_format
 * @return {string} type_figure.type_class
 */
function getFigureType(booking) {
    if (booking.isMatch()) {
        return {
            type_format: 'partido',
            type_class: 'match',
        };
    }
    if (booking.isPending()) {
        return {
            type_format: 'pendiente',
            type_class: 'pending',
        };
    }
    if (booking.isOnline()) {
        return {
            type_format: 'online',
            type_class: 'online',
        };
    }
    if (booking.isFixed()) {
        return {
            type_format: 'fijo',
            type_class: 'fixed',
        };
    } else {
        return {
            type_format: 'unico',
            type_class: 'once',
        };
    }
}

export default CalendarEvent;
